var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1X1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_1X1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1X1",
    "data-name": "1X1",
    clipPath: "url(#clip-_1X1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6513",
    "data-name": "Group 6513"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4864",
    "data-name": "Rectangle 4864",
    width: 130,
    height: 130,
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_370076_account_avatar_client_male_person_icon",
    "data-name": "370076_account_avatar_client_male_person_icon",
    d: "M54.824,5A48.716,48.716,0,1,0,103.54,53.715,48.713,48.713,0,0,0,54.824,5Zm0,4.06A44.627,44.627,0,0,1,89.157,82.232C84.7,80.373,74.195,76.725,67.689,74.8c-.555-.174-.642-.2-.642-2.511A13.327,13.327,0,0,1,68.6,66.84a27.959,27.959,0,0,0,2.165-7.4c.987-1.146,2.331-3.406,3.2-7.713.757-3.8.4-5.178-.1-6.474-.052-.137-.107-.272-.147-.406a42.322,42.322,0,0,1,.722-9.1,16.688,16.688,0,0,0-3.5-12.028c-2.141-2.738-6.236-6.1-13.717-6.565l-4.1,0c-7.354.464-11.453,3.824-13.594,6.561a16.686,16.686,0,0,0-3.5,12.026,42.372,42.372,0,0,1,.725,9.086,3.338,3.338,0,0,1-.151.424c-.5,1.3-.856,2.678-.1,6.474.86,4.307,2.2,6.567,3.2,7.713a27.667,27.667,0,0,0,2.165,7.4,13.168,13.168,0,0,1,.892,5.536c0,2.309-.087,2.337-.607,2.5-6.728,1.986-17.436,5.856-21.428,7.6A44.623,44.623,0,0,1,54.824,9.06ZM23.648,85.646c4.571-1.866,13.685-5.117,19.672-6.885,3.481-1.1,3.481-4.03,3.481-6.385a17.533,17.533,0,0,0-1.277-7.265,22.955,22.955,0,0,1-1.879-6.763A2.011,2.011,0,0,0,42.959,57c-.575-.5-1.744-2.347-2.49-6.066-.591-2.944-.341-3.588-.1-4.21a7.875,7.875,0,0,0,.282-.823c.488-1.782-.056-7.636-.646-10.882a12.707,12.707,0,0,1,2.708-8.8c2.367-3.027,5.951-4.714,10.522-5.005l3.85,0c4.694.3,8.278,1.982,10.649,5.009a12.7,12.7,0,0,1,2.7,8.8c-.587,3.245-1.134,9.1-.646,10.879.083.3.178.559.282.825.242.622.492,1.267-.1,4.21-.745,3.719-1.919,5.562-2.494,6.066a2.046,2.046,0,0,0-.686,1.352,22.849,22.849,0,0,1-1.875,6.763,17.236,17.236,0,0,0-1.935,7.182c0,2.355,0,5.287,3.516,6.395,5.729,1.693,14.887,4.839,19.723,6.741a44.558,44.558,0,0,1-62.579.218Z",
    transform: "translate(10.176 11.284)",
    fill: "#b6b9be"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1X1);
export default __webpack_public_path__ + "static/media/1X1.3c52e2db20f980c75aa32fd48101d88a.svg";
export { ForwardRef as ReactComponent };